import { FiPublicationActionType, ObjectTypes, PublicationType } from '@fi-shared/types';

export interface IPublicationSetting {
    IsPublicationSettingChanged?: boolean;
    IsShared?: boolean;
    PublicationType?: PublicationType;
    PublicationStartDate?: string; //ISO 8601 date
    PublicationEndDate?: string; //ISO 8601 date
    PublicationActionType?: FiPublicationActionType;
    PublicationSettingChangedByUserId?: number;
    PublicationSettingChangedByUserName?: string;
    PublicationSettingChangedOn?: string; //ISO 8601 date
}

export class PublicationSettingModel {
    IsShared: boolean = true;
    PublicationType: PublicationType = 1;
    PublicationActionType: FiPublicationActionType = FiPublicationActionType.UnpublishDocument;
    PublicationStartDate: any = new Date();

    //PublicationStartDateText = fiFormatDate(this.PublicationStartDate, FiDateFormatOptions);
    PublicationEndDate: any /* = new Date()*/;
    //PublicationEndDateText = fiFormatDate(this.PublicationEndDate, FiDateFormatOptions);
    PublicationSettingChangedByUserId = 0;
    PublicationSettingChangedByUserName = '';
    PublicationSettingChangedOn: any = new Date();
    IsPublicationSettingChanged = false;
    ObjectType;

    constructor(objectType?) {
        this.ObjectType = objectType || ObjectTypes.Document;
        this.PublicationStartDate.setHours(0, 0, 0, 0);
        /*this.PublicationEndDate.setHours(0, 0, 0, 0);
        this.PublicationEndDate.setMonth(this.PublicationEndDate.getMonth() + 3);*/
    }

    Initialize(publicationItem: PublicationSettingModel | IPublicationSetting) {
        this.IsShared = publicationItem.IsShared;
        this.PublicationType = publicationItem.PublicationType;
        this.PublicationActionType = publicationItem.PublicationActionType;
        this.PublicationSettingChangedByUserId = publicationItem.PublicationSettingChangedByUserId;
        this.PublicationSettingChangedByUserName = publicationItem.PublicationSettingChangedByUserName;
        this.IsPublicationSettingChanged = publicationItem.IsPublicationSettingChanged;
        if (publicationItem.PublicationStartDate != null) {
            this.PublicationStartDate = new Date(publicationItem.PublicationStartDate);
            //this.PublicationStartDate.setHours(0, 0, 0, 0);
            //this.PublicationStartDateText = fiFormatDate(this.PublicationStartDate,FiDateFormatOptions);
        }
        if (publicationItem.PublicationEndDate != null) {
            this.PublicationEndDate = new Date(publicationItem.PublicationEndDate);
            //this.PublicationEndDate.setHours(0, 0, 0, 0);
            //this.PublicationEndDateText = fiFormatDate(this.PublicationEndDate,FiDateFormatOptions);
        }
        if (publicationItem.PublicationSettingChangedOn != null) {
            this.PublicationSettingChangedOn = new Date(publicationItem.PublicationSettingChangedOn);
        }
    }

    IsChanged(publication) {
        let isChanged =
            this.IsShared !== publication.IsShared ||
            this.PublicationType !== publication.PublicationType ||
            this.PublicationActionType !== publication.PublicationActionType ||
            this.PublicationStartDate?.getTime() !== publication.PublicationStartDate?.getTime();
        if (this.PublicationType === PublicationType.TimeLimited) {
            isChanged = isChanged || this.PublicationEndDate?.getTime() !== publication.PublicationEndDate?.getTime();
        }
        return isChanged;
    }

    ApplyToPublicationItem(publicationItem) {
        if (this.IsShared) {
            this.IsPublicationSettingChanged = this.IsChanged(publicationItem.PublicationSetting);
            if (this.PublicationType == PublicationType.Continous) {
                this.PublicationEndDate = null;
                this.PublicationActionType = FiPublicationActionType.UnpublishDocument;
            } else if (this.PublicationType == PublicationType.TimeLimited) {
                //
            }
        }

        publicationItem.PublicationSetting.Initialize(this);
    }

    /* todo move logic to FiEditPublicationComponent
     */
    getPlainObject(): IPublicationSetting {
        return {
            IsPublicationSettingChanged: this.IsPublicationSettingChanged,
            IsShared: this.IsShared,
            PublicationActionType: this.PublicationActionType,
            PublicationEndDate: this.PublicationEndDate,
            PublicationSettingChangedByUserId: this.PublicationSettingChangedByUserId,
            PublicationSettingChangedByUserName: this.PublicationSettingChangedByUserName,
            PublicationSettingChangedOn: this.PublicationSettingChangedOn,
            PublicationStartDate: this.PublicationStartDate,
            PublicationType: this.PublicationType,
        };
    }

    static getNewInstance(): IPublicationSetting {
        return {
            IsShared: true,
            IsPublicationSettingChanged: true,
            PublicationType: PublicationType.Continous,
            PublicationActionType: FiPublicationActionType.UnpublishDocument,
        };
    }
}
